<div class="content">
    <!-- Begin dashboard -->
    <div class="container-fluid">
        <!-- Page Heading -->
        <div class="row ">
            <div class="col d-flex align-items-center justify-content-between mb-4">
                <h1 class="dashboard-title">Conflicted Accounts</h1>
            </div>
        </div>

        <!-- Content Row -->
            <!-- =====================================================
                CONFLICTED ACCOUNTS TOOLBAR
                ===================================================== -->
            <div class="row align-items-center conflict-toolbar">

                <!-- SEARCH -->
                <div class="col-lg-7 col-md-12 col-sm-12 conflict-search-column">

                    <div class="google-search-container">

                        <i class="fa fa-search search-icon"></i>

                        <input
                            (keyup)="handleKeyUp($event)"
                            #searchBox
                            class="google-search-input"
                            type="text"
                            placeholder="Search conflicted accounts..."
                        />

                        <i
                            *ngIf="searchBox.value"
                            class="fa fa-times clear-icon"
                            (click)="clearSearch(searchBox)">
                        </i>

                    </div>

                </div>


                <!-- PPO / HMO -->
                <div class="col-lg-2 col-md-4 col-sm-12 conflict-plan-column">

                    <div class="conflict-plan-toggle">

                        <button
                            type="button"
                            class="conflict-plan-option"
                            [class.active]="selectedPlanType === 'PPO'"
                            (click)="onPlanTypeToggle('PPO')">

                            PPO

                        </button>

                        <button
                            type="button"
                            class="conflict-plan-option"
                            [class.active]="selectedPlanType === 'HMO'"
                            (click)="onPlanTypeToggle('HMO')">

                            HMO

                        </button>

                    </div>

                </div>


                <!-- ACTIONS -->
                <div class="col-lg-3 col-md-8 col-sm-12 conflict-actions-column">

                    <div
                        class="listing-toolbar-actions conflict-action-bar"
                        [class.has-selection]="assignArray.length !== 0">


                        <!-- DELETE / RESTORE -->
                        <div
                            *ngIf="assignArray.length !== 0"
                            class="listing-selection-actions">

                            <button
                                type="button"
                                class="listing-btn listing-btn-danger listing-shrink-on-selection"
                                (click)="DeleteDuplicate(false)"
                                title="Delete">

                                <i class="fa-solid fa-trash-can"></i>

                                <span class="listing-btn-label">
                                    Delete
                                </span>

                            </button>


                            <button
                                type="button"
                                class="listing-btn listing-btn-success listing-shrink-on-selection"
                                (click)="changeStatus(false)"
                                title="Restore">

                                <i class="fa-solid fa-rotate-left"></i>

                                <span class="listing-btn-label">
                                    Restore
                                </span>

                            </button>

                        </div>


                        <!-- FILTER -->
                        <div
                            class="conflict-filter-wrapper"
                            #dropdownContainer>

                            <button
                                type="button"
                                class="
                                    listing-btn
                                    listing-btn-secondary
                                    listing-filter-btn
                                    listing-shrink-on-selection
                                "
                                [class.active]="isDropdownOpen"
                                (click)="toggleDropdown()"
                                title="Filters">

                                <i class="fa-solid fa-sliders"></i>

                                <span class="listing-btn-label">
                                    Filters
                                </span>

                                <span
                                    *ngIf="
                                        filter.status !== null ||
                                        filter.verification ||
                                        filter.agent ||
                                        (filter.startDate && filter.endDate) ||
                                        (filter.wStartDate && filter.wEndDate)
                                    "
                                    class="listing-filter-count">

                                    <i class="fa-solid fa-check"></i>

                                </span>

                            </button>


                            <!-- FILTER POPOVER -->
                            <div
                                class="conflict-filter-popover"
                                [hidden]="!isDropdownOpen"
                                (click)="$event.stopPropagation()">


                                <!-- HEADER -->
                                <div class="conflict-filter-header">

                                    <div>

                                        <div class="conflict-filter-title-row">

                                            <span class="conflict-filter-title">
                                                Filters
                                            </span>

                                            <span
                                                *ngIf="
                                                    filter.status !== null ||
                                                    filter.verification ||
                                                    filter.agent ||
                                                    (filter.startDate && filter.endDate) ||
                                                    (filter.wStartDate && filter.wEndDate)
                                                "
                                                class="conflict-filter-active-badge">

                                                Active

                                            </span>

                                        </div>

                                        <div class="conflict-filter-subtitle">
                                            Refine conflicted accounts using one or more filters.
                                        </div>

                                    </div>


                                    <button
                                        type="button"
                                        class="conflict-filter-close"
                                        (click)="toggleDropdown()"
                                        title="Close">

                                        <i class="fa-solid fa-xmark"></i>

                                    </button>

                                </div>


                                <!-- BODY -->
                                <div class="conflict-filter-body">


                                    <!-- =================================================
                                        FILTER TYPES
                                        ================================================= -->
                                    <div class="conflict-filter-section">

                                        <div class="conflict-filter-label">
                                            Filter By
                                        </div>


                                        <!-- APPOINTMENT -->
                                        <div
                                            class="conflict-filter-type"
                                            [class.active]="filter.filterType === 'date'"
                                            (click)="setFilterType('date')">

                                            <div class="conflict-filter-type-left">

                                                <span class="conflict-filter-type-icon">
                                                    <i class="fa-regular fa-calendar"></i>
                                                </span>

                                                <div>

                                                    <div class="conflict-filter-type-title">
                                                        Appointment Date
                                                    </div>

                                                    <div class="conflict-filter-type-hint">
                                                        Filter using appointment date.
                                                    </div>

                                                </div>

                                            </div>


                                            <input
                                                type="checkbox"
                                                [checked]="
                                                    (startDate && endDate) ||
                                                    (filter.startDate && filter.endDate)
                                                "
                                                (click)="$event.stopPropagation()"
                                                (change)="toggleFilter('date', $event)"
                                            />

                                        </div>


                                        <!-- WOD -->
                                        <div
                                            class="conflict-filter-type"
                                            [class.active]="filter.filterType === 'wdate'"
                                            (click)="setFilterType('wdate')">

                                            <div class="conflict-filter-type-left">

                                                <span class="conflict-filter-type-icon">
                                                    <i class="fa-regular fa-clock"></i>
                                                </span>

                                                <div>

                                                    <div class="conflict-filter-type-title">
                                                        Work Order Date
                                                    </div>

                                                    <div class="conflict-filter-type-hint">
                                                        Filter using WOD.
                                                    </div>

                                                </div>

                                            </div>


                                            <input
                                                type="checkbox"
                                                [checked]="
                                                    (wstartDate && wendDate) ||
                                                    (filter.wStartDate && filter.wEndDate)
                                                "
                                                (click)="$event.stopPropagation()"
                                                (change)="toggleFilter('wdate', $event)"
                                            />

                                        </div>


                                        <!-- STATUS -->
                                        <div
                                            class="conflict-filter-type"
                                            [class.active]="filter.filterType === 'status'"
                                            (click)="setFilterType('status')">

                                            <div class="conflict-filter-type-left">

                                                <span class="conflict-filter-type-icon">
                                                    <i class="fa-solid fa-circle-check"></i>
                                                </span>

                                                <div>

                                                    <div class="conflict-filter-type-title">
                                                        Status
                                                    </div>

                                                    <div class="conflict-filter-type-hint">
                                                        Active, inactive or all accounts.
                                                    </div>

                                                </div>

                                            </div>


                                            <input
                                                type="checkbox"
                                                [checked]="
                                                    filter.status !== null &&
                                                    filter.status !== undefined
                                                "
                                                (click)="$event.stopPropagation()"
                                                (change)="toggleFilter('status', $event)"
                                            />

                                        </div>


                                        <!-- VERIFICATION -->
                                        <div
                                            class="conflict-filter-type"
                                            [class.active]="filter.filterType === 'verification'"
                                            (click)="setFilterType('verification')">

                                            <div class="conflict-filter-type-left">

                                                <span class="conflict-filter-type-icon">
                                                    <i class="fa-solid fa-shield"></i>
                                                </span>

                                                <div>

                                                    <div class="conflict-filter-type-title">
                                                        Verification
                                                    </div>

                                                    <div class="conflict-filter-type-hint">
                                                        Filter by verification state.
                                                    </div>

                                                </div>

                                            </div>


                                            <input
                                                type="checkbox"
                                                [checked]="filter.verification"
                                                (click)="$event.stopPropagation()"
                                                (change)="toggleFilter('verification', $event)"
                                            />

                                        </div>


                                        <!-- AGENT -->
                                        <div
                                            class="conflict-filter-type"
                                            [class.active]="filter.filterType === 'agent'"
                                            (click)="setFilterType('agent')">

                                            <div class="conflict-filter-type-left">

                                                <span class="conflict-filter-type-icon">
                                                    <i class="fa-regular fa-user"></i>
                                                </span>

                                                <div>

                                                    <div class="conflict-filter-type-title">
                                                        Agent
                                                    </div>

                                                    <div class="conflict-filter-type-hint">
                                                        Filter by assigned agent.
                                                    </div>

                                                </div>

                                            </div>


                                            <input
                                                type="checkbox"
                                                [checked]="filter.agent"
                                                (click)="$event.stopPropagation()"
                                                (change)="toggleFilter('agent', $event)"
                                            />

                                        </div>

                                    </div>


                                    <!-- =================================================
                                        APPOINTMENT DATE
                                        ================================================= -->
                                    <div
                                        *ngIf="filter.filterType === 'date'"
                                        class="conflict-filter-section">

                                        <div class="conflict-filter-section-heading">

                                            <span class="conflict-filter-section-icon">
                                                <i class="fa-regular fa-calendar"></i>
                                            </span>

                                            <div>

                                                <div class="conflict-filter-section-title">
                                                    Appointment Date
                                                </div>

                                                <div class="conflict-filter-section-hint">
                                                    Select a start and end date.
                                                </div>

                                            </div>

                                        </div>


                                        <div class="conflict-filter-date-grid">

                                            <div class="conflict-filter-field">

                                                <label>From</label>

                                                <input
                                                    type="text"
                                                    id="startDate"
                                                    #startDateInput
                                                    class="form-control conflict-filter-input"
                                                    placeholder="MM/DD/YYYY"
                                                    bsDatepicker
                                                    [(ngModel)]="filter.startDate"
                                                    [bsConfig]="{
                                                        dateInputFormat: 'MM/DD/YYYY',
                                                        placement: 'bottom',
                                                        containerClass: 'theme-blue'
                                                    }"
                                                />

                                            </div>


                                            <div class="conflict-filter-field">

                                                <label>To</label>

                                                <input
                                                    type="text"
                                                    id="endDate"
                                                    #endDateInput
                                                    class="form-control conflict-filter-input"
                                                    placeholder="MM/DD/YYYY"
                                                    bsDatepicker
                                                    [(ngModel)]="filter.endDate"
                                                    [minDate]="filter.startDate"
                                                    [bsConfig]="{
                                                        dateInputFormat: 'MM/DD/YYYY',
                                                        placement: 'bottom',
                                                        containerClass: 'theme-blue'
                                                    }"
                                                />

                                            </div>

                                        </div>

                                    </div>


                                    <!-- =================================================
                                        WOD
                                        ================================================= -->
                                    <div
                                        *ngIf="filter.filterType === 'wdate'"
                                        class="conflict-filter-section">

                                        <div class="conflict-filter-section-heading">

                                            <span class="conflict-filter-section-icon">
                                                <i class="fa-regular fa-clock"></i>
                                            </span>

                                            <div>

                                                <div class="conflict-filter-section-title">
                                                    Work Order Date
                                                </div>

                                                <div class="conflict-filter-section-hint">
                                                    Select a work-order date range.
                                                </div>

                                            </div>

                                        </div>


                                        <div class="conflict-filter-date-grid">

                                            <div class="conflict-filter-field">

                                                <label>From</label>

                                                <input
                                                    type="text"
                                                    id="wstartDate"
                                                    class="form-control conflict-filter-input"
                                                    placeholder="MM/DD/YYYY"
                                                    bsDatepicker
                                                    [(ngModel)]="filter.wStartDate"
                                                    [bsConfig]="{
                                                        dateInputFormat: 'MM/DD/YYYY',
                                                        placement: 'bottom',
                                                        containerClass: 'theme-blue'
                                                    }"
                                                />

                                            </div>


                                            <div class="conflict-filter-field">

                                                <label>To</label>

                                                <input
                                                    type="text"
                                                    id="wendDate"
                                                    class="form-control conflict-filter-input"
                                                    placeholder="MM/DD/YYYY"
                                                    bsDatepicker
                                                    [(ngModel)]="filter.wEndDate"
                                                    [minDate]="filter.wStartDate"
                                                    [bsConfig]="{
                                                        dateInputFormat: 'MM/DD/YYYY',
                                                        placement: 'bottom',
                                                        containerClass: 'theme-blue'
                                                    }"
                                                />

                                            </div>

                                        </div>

                                    </div>


                                    <!-- =================================================
                                        STATUS
                                        ================================================= -->
                                    <div
                                        *ngIf="filter.filterType === 'status'"
                                        class="conflict-filter-section">

                                        <div class="conflict-filter-label">
                                            Status
                                        </div>

                                        <div class="conflict-filter-choice-grid">

                                            <button
                                                type="button"
                                                class="conflict-filter-choice"
                                                [class.active]="filter.status === null"
                                                (click)="
                                                    setFilterType('status','all');
                                                    filter.status = null
                                                ">

                                                All

                                            </button>


                                            <button
                                                type="button"
                                                class="conflict-filter-choice"
                                                [class.active]="filter.status === true"
                                                (click)="
                                                    setFilterType('status','active');
                                                    filter.status = true
                                                ">

                                                Active

                                            </button>


                                            <button
                                                type="button"
                                                class="conflict-filter-choice"
                                                [class.active]="filter.status === false"
                                                (click)="
                                                    setFilterType('status','inactive');
                                                    filter.status = false
                                                ">

                                                Inactive

                                            </button>

                                        </div>

                                    </div>


                                    <!-- =================================================
                                        VERIFICATION
                                        ================================================= -->
                                    <div
                                        *ngIf="filter.filterType === 'verification'"
                                        class="conflict-filter-section">

                                        <div class="conflict-filter-label">
                                            Verification
                                        </div>

                                        <div class="conflict-filter-choice-grid verification">

                                            <button
                                                type="button"
                                                class="conflict-filter-choice"
                                                (click)="
                                                    setFilterType('verification','VERIFIED');
                                                    applyVerificationFilter('VERIFIED')
                                                ">

                                                Verified

                                            </button>


                                            <button
                                                type="button"
                                                class="conflict-filter-choice"
                                                (click)="
                                                    setFilterType('verification','PENDING');
                                                    applyVerificationFilter('PENDING')
                                                ">

                                                In Progress

                                            </button>


                                            <button
                                                type="button"
                                                class="conflict-filter-choice"
                                                (click)="
                                                    setFilterType('verification','NOT_VERIFIED');
                                                    applyVerificationFilter('NOT_VERIFIED')
                                                ">

                                                Not Verified

                                            </button>


                                            <button
                                                type="button"
                                                class="conflict-filter-choice"
                                                (click)="
                                                    setFilterType('verification','BACKLOG');
                                                    applyVerificationFilter('BACKLOG')
                                                ">

                                                Backlog

                                            </button>


                                            <button
                                                type="button"
                                                class="conflict-filter-choice"
                                                (click)="
                                                    setFilterType('verification','UNASSIGNED');
                                                    applyVerificationFilter('UNASSIGNED')
                                                ">

                                                Unassigned

                                            </button>

                                        </div>

                                    </div>


                                    <!-- =================================================
                                        AGENT
                                        ================================================= -->
                                    <div
                                        *ngIf="filter.filterType === 'agent'"
                                        class="conflict-filter-section">

                                        <div class="conflict-filter-label">
                                            Agent
                                        </div>


                                        <mat-form-field
                                            appearance="outline"
                                            class="conflict-agent-select">

                                            <mat-select
                                                [(ngModel)]="filter.agent"
                                                placeholder="Select Agent">

                                                <mat-select-trigger>

                                                    <span class="conflict-selected-agent">
                                                        {{ getConflictAgentName(filter.agent) }}
                                                    </span>

                                                </mat-select-trigger>


                                                <mat-select-filter
                                                    #filterSelect
                                                    [array]="agentArray"
                                                    [displayMember]="'fullName'"
                                                    (filteredReturn)="onFilteredReturn($event)"
                                                    (click)="$event.stopPropagation()">
                                                </mat-select-filter>


                                                <mat-option
                                                    *ngFor="let agent of filterAgentArray; trackBy: trackByAgentId"
                                                    [value]="agent.id">

                                                    {{ agent.firstName }}
                                                    {{ agent.lastName }}

                                                </mat-option>

                                            </mat-select>

                                        </mat-form-field>

                                    </div>

                                </div>


                                <!-- FOOTER -->
                                <div class="conflict-filter-footer">

                                    <button
                                        type="button"
                                        class="listing-btn listing-btn-secondary"
                                        (click)="resetFilter($event)">

                                        <i class="fa-solid fa-rotate-left"></i>
                                        Reset

                                    </button>


                                    <button
                                        type="button"
                                        class="listing-btn listing-btn-primary"
                                        (click)="_fetchData(); toggleDropdown()">

                                        <i class="fa-solid fa-check"></i>
                                        Apply Filters

                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>




            <!-- Table -->
            <div class="col-12">

                    <div class="table-panel p-4">
                        <div class="table-responsive table-scroll-x">
                            <table class="table table-sm" matSort (matSortChange)="sortData($event)">
                                <thead>
                                <tr>
                                    <th scope="col">Sr.No</th>
                                    <th scope="col">Batch-Status</th>
                                    <th *ngIf="this.authService.hasRole('client-edit')" scope="col"><input
                                            type="checkbox" [checked]="checked" (click)="assign('All')">&nbsp;
                                        Select
                                    </th>
                                    <th scope="col">Assigned-To</th>
                                    <th scope="col">Verification</th>
                                    <th mat-sort-header="firstName" scope="col">Name</th>
                                    <th mat-sort-header="dob" scope="col">DOB</th>
                                    <th mat-sort-header="patientId" scope="col">PatientId</th>
                                    <th mat-sort-header="formType" scope="col">Form Type</th>
                                    <th mat-sort-header="insuranceType" scope="col">Ins-Type</th>
                                    <th mat-sort-header="payerName" scope="col">Career Name</th>
                                    <th mat-sort-header="careerName" scope="col">Payer ID</th>
                                    <th mat-sort-header="insuranceID" scope="col">Ins-Id</th>
                                    <th mat-sort-header="insurancePhone" scope="col">Ins-phone</th>
                                    <th mat-sort-header="apptDate" scope="col">App-Date</th>
                                    <th mat-sort-header="apptTime" scope="col">App-Time</th>
                                    <th mat-sort-header="providerName" scope="col">Provider Name</th>
                                    <th mat-sort-header="officeName" scope="col">Office</th>
                                    <th mat-sort-header="groupNo" scope="col">Grp-No</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody *ngFor="let table of tableData; let i = index; trackBy: trackByPatientId">
                                <tr>
                                    <th scope="row">{{i + 1}}</th>
                                    <td *ngIf="table.batchJobStatus === 'SUCCESS'">
                                        <div class="btn-neon neon-green">
                                            <a class="button success-btn">
                                                <span></span> <span></span> <span></span> <span></span>
                                                Success
                                            </a>
                                        </div>
                                    </td>
                                    <td *ngIf="table.batchJobStatus === 'PENDING'">
                                        <div class="btn-neon neon-yellow">
                                            <a class="button pending-btn">
                                                <span></span> <span></span> <span></span> <span></span>
                                                Pending
                                            </a>
                                        </div>
                                    </td>
                                    <td *ngIf="table.batchJobStatus === 'FAILED'">
                                        <div class="btn-neon neon-red">
                                            <a class="button failed-btn"
                                               matTooltip="{{ table.apiErrorMessage || 'No error details available' }}"
                                               matTooltipPosition="above">
                                                <span></span> <span></span> <span></span> <span></span>
                                                Failed
                                            </a>
                                        </div>
                                    </td>
                                    <td *ngIf="!table.batchJobStatus"><i class="btn-neon neon-gray">-</i></td>
                                    <td *ngIf="this.authService.hasRole('client-edit')"><input type="checkbox"
                                                                                               [checked]="table.assignedF"
                                                                                               (click)="assign(table.id)">
                                    </td>
                                    <td>{{table.staffName ? table.staffName : 'N/A'}}</td>

                                    <td *ngIf="table.verification === 'VERIFIED'">
                                        <div class="btn-neon neon-green">
                                            <button> Verified</button>
                                        </div>
                                    </td>
                                    <td *ngIf="table.verification === 'PENDING'">
                                        <div class="btn-neon neon-yellow">
                                            <button> In Progress</button>
                                        </div>
                                    </td>
                                    <td *ngIf="table.verification === 'NOT_VERIFIED'">
                                        <div class="btn-neon neon-red">
                                            <button> Not Verified</button>
                                        </div>
                                    </td>
                                    <td *ngIf="table.verification === 'BACKLOG'">
                                        <div class="btn-neon neon-gray">
                                            <button> Backlog</button>
                                        </div>
                                    </td>
                                    <td *ngIf="table.verification === 'UNASSIGNED'">
                                        <div class="btn-neon neon-blue">
                                            <button> Unassigned</button>
                                        </div>
                                    </td>
                                    <td *ngIf="!table.verification"><i class="fa-solid fa-circle"
                                                                       style="color: gray"></i></td>

                                    <td>
                                        <a [routerLink]="this.authService.hasRole('client-edit')?['details/', table.id]:null" [queryParams]="{ officeId: table.officeId, planCreation: table.planCreation }">{{table.firstName ? table.firstName + ' ' + table.lastName : '-'}}</a>
                                    </td>
                                    <td>{{ table.dob ? (table.dob | date: 'MM/dd/yyyy') : '-' }}</td>
                                    <td>{{table.patientId ? table.patientId : '-'}}</td>
                                    <td>{{table.formType ? table.formType : '-'}}</td>
                                    <td>{{table.insuranceType ? table.insuranceType : '-'}}</td>
                                    <td>{{table.payerName ? table.payerName : '-'}}</td>
                                    <td>{{table.careerName ? table.careerName : '-'}}</td>
                                    <td>{{table.insuranceId ? table.insuranceId : '-'}}</td>
                                    <td>{{table.insurancePhone ? table.insurancePhone : '-'}}</td>
                                    <td>{{table.apptDate ? (table.apptDate | date:'MM/dd/yyyy') : '-'}}</td>
                                    <td>{{table.apptTime ? table.apptTime : '-'}}</td>
                                    <td>{{table.providerName ? table.providerName : '-'}}</td>
                                    <td>{{table.officeName ? table.officeName : '-'}}</td>
                                    <td>{{table.groupNo ? table.groupNo : '-'}}</td>
                                    <td *ngIf="table.active"><i class="fa-solid fa-square-check"
                                                                style="color: #34ce57"></i></td>
                                    <td *ngIf="!table.active"><i class="fa-solid fa-square-xmark"
                                                                 style="color: #dc3545"></i></td>

                                    <td>
                                        <a title="Edit"
                                           [routerLink]="this.authService.hasRole('client-edit')?['details/', table.id]:null"><i
                                                class="fa-solid fa-user-pen"></i></a>&nbsp;&nbsp;
                                        <a title="Edit"
                                           [routerLink]="this.authService.hasRole('client-edit')?['/userworkarea/details/', table.id]:null" [queryParams]="{form:'patient', officeId: table.officeId, planCreation: table.planCreation}"><i
                                                class="fa-regular fa-eye"></i></a>

                                    </td>
                                </tr>
                                </tbody>
                                <tbody *ngIf="tableData?.length === 0">
                                <tr>
                                    <td colspan="18" class="text-center"> No record found !</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="tableData?.length !== 0" class="d-flex justify-content-end mt-3">
                            <mat-paginator
                                    [length]="totalRecord"
                                    [pageIndex]="pagination.currentPage"
                                    [pageSize]="pagination.size"
                                    [pageSizeOptions]="[5, 10, 25, 100, 200, 300]"
                                    aria-label="Select page"
                                    showFirstLastButtons
                                    color="warn"
                                    (page)="pageChange($event)">
                            </mat-paginator>
                        </div>
                    </div>

            </div>
        </div>
    </div>
</div>

<!-- Bulk Upload Modal -->
